module.exports = __webpack_public_path__ + "static/media/arrow-square-left.d8ac1fae.svg";